import React from 'react';

const TermsOfService = () => {
  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl text-left">
      <h1 className="text-3xl font-bold mb-8 text-left">Terms of Service</h1>

      <div className="prose prose-lg max-w-none text-left">
        <p>Effective Date: March 25th, 2025</p>

        <p className="mt-4">
          These Terms of Service ("Terms") govern your access to and use of the website and digital products provided ("we," "our," or "us"). By accessing or using our website and services, you agree to comply with these Terms. Please read them carefully before using our services.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">1. Acceptance of Terms</h2>
        <p>
          By accessing or purchasing from our website, you agree to be bound by these Terms and our Privacy Policy. If you do not agree with these Terms, do not use our website or purchase any products.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">2. Eligibility</h2>
        <p>
          You must be at least 18 years old or have the consent of a parent or legal guardian to use our services and make purchases. By using our website, you represent and warrant that you meet this eligibility requirement.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">3. Digital Products</h2>
        <p>
          We offer digital products for sale through our website. Upon purchase, you are granted a non-exclusive, non-transferable license to use the digital product according to the terms outlined below.
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>The products provided are for personal, non-commercial use unless otherwise stated.</li>
          <li>You may not resell, distribute, or modify the products without prior written consent.</li>
          <li>We reserve the right to modify, suspend, or discontinue the products or services at any time without notice.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">4. Ordering and Payment</h2>
        <p><strong>Orders:</strong> By placing an order on our website, you agree to pay for the digital product(s) you have selected at the price indicated.</p>
        <p><strong>Payment:</strong> All transactions are processed through our payment processor. You agree to provide accurate payment details and ensure sufficient funds for your order.</p>
        <p><strong>Refunds:</strong> Due to the nature of digital products, all sales are final, and we do not offer refunds, except in cases where the product is not delivered or there is an error in processing your order. In such cases, please contact us at our support email.</p>

        <h2 className="text-2xl font-bold mt-8 mb-4">5. User Account</h2>
        <p>
          You may be required to create an account to access certain features of our website or complete a purchase. You agree to provide accurate and up-to-date information when creating an account. You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">6. Intellectual Property</h2>
        <p>
          All content on our website, including but not limited to digital products, graphics, text, logos, and software, is owned and is protected by copyright, trademark, and other intellectual property laws.
        </p>
        <p>
          You are granted a limited license to use the digital product(s) for personal use only. Any unauthorized use, reproduction, or distribution of our intellectual property is prohibited.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">7. Prohibited Activities</h2>
        <p>You agree not to engage in any of the following activities:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Violating any applicable laws or regulations.</li>
          <li>Distributing or transmitting harmful code (e.g., viruses, malware) through our website.</li>
          <li>Using the website for any unlawful or fraudulent purposes.</li>
          <li>Attempting to reverse engineer or interfere with the functionality of our digital products.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">8. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, we will not be liable for any indirect, incidental, special, or consequential damages arising out of or related to your use of our website or digital products.
        </p>
        <p>
          Our total liability will not exceed the amount you paid for the digital product in question.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">9. Termination</h2>
        <p>
          We reserve the right to suspend or terminate your access to our website and services if you violate any of these Terms or engage in any fraudulent activity.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">10. Modifications to Terms</h2>
        <p>
          We may update these Terms at any time. Any changes will be posted on this page with an updated effective date. By continuing to use our services after any modifications, you agree to be bound by the updated Terms.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">11. Governing Law</h2>
        <p>
          These Terms will be governed by and construed in accordance with the laws of Arizona, USA, without regard to its conflict of law principles.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">12. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding these Terms, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:support@applaunchai.com">support@applaunchai.com</a>
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
